import {
  richtext_default
} from "./chunk-KYXE3IBT.js";
import {
  show_run_label_default
} from "./chunk-UQ7EFRTL.js";
import {
  sanity_image_default
} from "./chunk-S7ZUUURB.js";
import {
  title_default
} from "./chunk-GI6JXUKL.js";
import {
  icon_default
} from "./chunk-KWWZIFUJ.js";
import {
  link_default
} from "./chunk-6WQWOYMP.js";

// src/cards/historical-show/historical-show.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CardHistoricalShow = forwardRef(
  ({
    className = "",
    description,
    endDate,
    id,
    image,
    labels = {
      learnMore: "Learn More",
      showingFrom: "Showing From"
    },
    startDate = { local: "" },
    targetPage,
    title
  }, ref) => {
    if (!title) return null;
    return /* @__PURE__ */ jsxs(
      "article",
      {
        className: `${className} group relative auto-rows-min theme-light grid grid-cols-5 gap-x-6 grid-rows-auto lg:grid-rows-1 auto-rows-max`,
        id,
        ref,
        children: [
          image && /* @__PURE__ */ jsx(
            sanity_image_default,
            {
              className: "col-start-1 col-span-5 lg:col-span-2 order-1 relative aspect-312/208 lg:aspect-200/300 w-full lg:w-auto lg:h-full row-start-1 rounded-sm overflow-hidden",
              imageClassName: "object-cover h-full w-auto group-hover:scale-[105%] transition-card-image",
              sanityImageSourceData: image,
              height: 300,
              width: 200
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "col-start-1 col-span-5 pt-3 lg:pt-0 lg:col-start-3 lg:col-span-3 row-start-2 lg:row-start-1 flex flex-col", children: [
            title && /* @__PURE__ */ jsx(
              title_default,
              {
                className: "title-md col-start-3 col-span-3 order-2 pb-6  text-heritage-red-full ",
                level: "h3",
                text: title
              }
            ),
            startDate && /* @__PURE__ */ jsx(
              show_run_label_default,
              {
                className: "body-xs col-start-3 order-1 pb-1 uppercase",
                endDate,
                startDate
              }
            ),
            description && /* @__PURE__ */ jsx("div", { className: "body-md line-clamp-4 col-start-3 col-span-3 order-3 overflow-hidden pr-3 lg:pr-0 lg:mt-auto", children: /* @__PURE__ */ jsx(richtext_default, { text: description }) }),
            targetPage && /* @__PURE__ */ jsx("div", { className: "card-wrapping-link col-start-3 col-span-3 order-4 pt-6 pb-1", children: /* @__PURE__ */ jsxs(
              link_default,
              {
                className: "link w-fit",
                href: targetPage || "#",
                tracking: {
                  component: "Card Historical Show",
                  label: labels?.learnMore
                },
                children: [
                  labels?.learnMore,
                  /* @__PURE__ */ jsx(
                    icon_default,
                    {
                      name: "arrow-short-right",
                      className: "h-[0.7em] pt-[0.1em] group-hover:translate-x-1 transition-translate",
                      SVGClassName: "w-auto h-full"
                    }
                  )
                ]
              }
            ) })
          ] })
        ]
      }
    );
  }
);
var historical_show_default = CardHistoricalShow;

export {
  historical_show_default
};
